export default __webpack_public_path__ + "static/media/BGSplash.de919590.jpg";